import { useCallback } from 'react';
export function usePixKeysListActions({ handleCopyKey, handleCopy, handleDelete, onValidate, handleCloseDeleteModal, handleConfirmDelete, getPixKeys, showDeleteSuccessToast, }) {
    const handleCopyWithKey = useCallback((key) => {
        handleCopyKey(key);
        handleCopy();
    }, [handleCopyKey, handleCopy]);
    const handleDeleteWithKey = useCallback((pixKey) => {
        handleDelete(pixKey);
    }, [handleDelete]);
    const handleValidateWithKey = useCallback((pixKey) => {
        onValidate?.(pixKey);
    }, [onValidate]);
    const handleConfirmDeleteWithKey = useCallback(async () => {
        handleCloseDeleteModal();
        const success = await handleConfirmDelete();
        if (success) {
            await getPixKeys();
            showDeleteSuccessToast();
        }
    }, [handleConfirmDelete, handleCloseDeleteModal, getPixKeys, showDeleteSuccessToast]);
    return {
        handleCopyWithKey,
        handleDeleteWithKey,
        handleValidateWithKey,
        handleConfirmDeleteWithKey,
    };
}
